import BarChartIcon from "@mui/icons-material/BarChart";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import MilitaryTechIcon from "@mui/icons-material/MilitaryTech";
import NumberBox from "./NumberBox";

type RankingNumberProps = {
  number: any;
  variant?: any;
  title: any;
  subtitle?: any;
};

export default function RankingNumber(props: RankingNumberProps) {
  var icon = (
    <BarChartIcon color="info" sx={{ width: "40px", height: "40px" }} />
  );
  var number = props.number;
  if (props.number == 1) {
    icon = (
      <EmojiEventsIcon color="warning" sx={{ width: "40px", height: "40px" }} />
    );
  }
  if (props.number == 2) {
    icon = (
      <MilitaryTechIcon
        color="disabled"
        sx={{ width: "40px", height: "40px" }}
      />
    );
  }
  if (props.number == 3) {
    icon = (
      <MilitaryTechIcon
        htmlColor="#CD7F32"
        sx={{ width: "40px", height: "40px" }}
      />
    );
  }
  if (props.number > 1000) {
    icon = (
      <BarChartIcon color="disabled" sx={{ width: "40px", height: "40px" }} />
    );
    number = "> 1000";
  }

  return (
    <NumberBox
      number={number}
      variant={props.variant}
      title={props.title}
      subtitle={props.subtitle}
      icon={icon}
    />
  );
}
